import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'

export interface AppSettings {
    appInsightsConnectionString: string | null
}

@Injectable({
    providedIn: 'root',
})
export class AppSettingsService {
    #http = inject(HttpClient)

    getAppSettings(): Observable<AppSettings> {
        return this.#http.get<AppSettings>('/api/app/settings')
    }
}
